<template>
  <div>
    <template v-if="userRole !== 'rrhh' && data?.length">
      <a-table
        :columns="columns"
        :data-source="data"
        :showHeader="false"
        :pagination="false"
        :loading="loadingReport || loadingMovementFiles || loadingProcessFile"
      >
        <template #title>
          <a-typography-text style="color: #475569; display: block">
            {{ title }}
          </a-typography-text>
        </template>

        <template #desc="{ record }">
          <warning-outlined v-if="showWarningSign" class="text-error mr-2" />
          <check-circle-outlined v-else class="text-green-6 mr-2" />
          <a-typography-text class="text-gray-8">
            {{ record.message }}
          </a-typography-text>
        </template>

        <template #action="{ record }">
          <div style="display: flex; justify-content: flex-end">
            <a-button
              style="padding: 0"
              type="link"
              @click="downloadReport(record)"
              :loading="loadingReport"
            >
              Descargar
            </a-button>
          </div>
        </template>
      </a-table>
    </template>

    <template v-else>
      <a-collapse v-model:activeKey="activeKey" class="mb-2">
        <a-collapse-panel :key="1" :header="title">
          <a-typography-text style="color: #595959">
            No hay archivos procesados para este ticket.
          </a-typography-text>
        </a-collapse-panel>
      </a-collapse>
    </template>
  </div>
</template>

<script>
import { ref, computed, watch } from 'vue';
import { useStore } from 'vuex';
import {
  GET_LOGGED_USER,
  TICKET_GROUPS_GET_MOVEMENT_FILES,
  TICKET_GROUPS_GET_LOADING
} from '@/store/types';
import { WarningOutlined, CheckCircleOutlined } from '@ant-design/icons-vue';
import { getMovementProcessedFile } from '@/network';

export default {
  name: 'ProcessedFileTable',
  components: {
    'warning-outlined': WarningOutlined,
    'check-circle-outlined': CheckCircleOutlined
  },
  props: {
    ticketGroupId: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: 'Archivo procesado'
    },
    loadingMovementFiles: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const store = useStore();
    const activeKey = ref([]);
    const userRole = computed(
      () => store.getters[GET_LOGGED_USER]?.roleName || ''
    );

    const loadingReport = ref(false);
    const fileProcess = ref(null);

    const movementFilesData = computed(
      () => store.getters[TICKET_GROUPS_GET_MOVEMENT_FILES]
    );
    const loadingProcessFile = computed(
      () => store.getters[TICKET_GROUPS_GET_LOADING].fetchMovementFiles
    );

    watch(movementFilesData, (newValue) => {
      const file = newValue?.movementFiles?.fileMovementProcess;
      fileProcess.value = file?.id ? file : null;
    });

    const downloadReport = () => {
      try {
        loadingReport.value = true;
        const url = getMovementProcessedFile(fileProcess.value.id);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'reporte.xlsx';
        link.click();
      } catch (error) {
        console.error('Error al descargar reporte:', error);
      } finally {
        loadingReport.value = false;
      }
    };

    const showWarningSign = ref(false);

    const data = computed(() => {
      if (!fileProcess.value) return [];

      showWarningSign.value = fileProcess.value.numberOfObservations > 0;

      const message =
        fileProcess.value.numberOfObservations > 0
          ? 'No se pudieron procesar todos los subtickets.'
          : 'Todos los subtickets fueron creados correctamente.';

      return [{ key: 1, message, id: fileProcess.value.id }];
    });

    const columns = [
      { dataIndex: 'message', key: 'desc', slots: { customRender: 'desc' } },
      { key: 'action', align: 'right', slots: { customRender: 'action' } }
    ];

    return {
      userRole,
      loadingReport,
      loadingProcessFile,
      columns,
      downloadReport,
      data,
      showWarningSign,
      activeKey
    };
  }
};
</script>
